var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sent"},[_c('header',[_c('img',{attrs:{"src":require("@/assets/images/icon-success-check.svg"),"alt":""}}),_c('h2',[_vm._v("Message Sent!")])]),_c('p',[_vm._v("Thanks for completing the form. We'll be in touch soon!")])])
}]

export { render, staticRenderFns }